
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/google-gemini-api-ui",
      function () {
        return require("private-next-pages/google-gemini-api-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/google-gemini-api-ui"])
      });
    }
  